/**
 * Bypass de QA del modo mantenimiento, por pestaña:
 *   ?mantenimiento=off  → esta pestaña se salta la pantalla de mantenimiento.
 *   ?mantenimiento=on   → quita el bypass (vuelve a ver la pantalla si el flag está encendido).
 * Vive en sessionStorage, así que muere al cerrar la pestaña y no afecta a nadie más.
 * Se captura en `main.tsx` ANTES de montar React, como el resto de los params de
 * URL (ver docs/deeplinks.md): el router puede reescribir la URL después.
 */
export const MAINTENANCE_BYPASS_PARAM = 'mantenimiento';
export const MAINTENANCE_BYPASS_STORAGE_KEY = 'heru_mantenimiento_bypass';

export const captureMaintenanceBypassFromUrl = (): void => {
	try {
		const value = new URLSearchParams(window.location.search).get(
			MAINTENANCE_BYPASS_PARAM,
		);
		if (value === 'off') sessionStorage.setItem(MAINTENANCE_BYPASS_STORAGE_KEY, '1');
		else if (value === 'on') sessionStorage.removeItem(MAINTENANCE_BYPASS_STORAGE_KEY);
	} catch {
		// sessionStorage no disponible: sin bypass, nunca bloquea el arranque.
	}
};

export const isMaintenanceBypassed = (): boolean => {
	try {
		return sessionStorage.getItem(MAINTENANCE_BYPASS_STORAGE_KEY) === '1';
	} catch {
		return false;
	}
};
